export default "__VITE_ASSET__9305c168__"